module.exports = __webpack_public_path__ + "static/media/view_claims_5.6bb9dd53.png";